module.exports = __webpack_public_path__ + "static/media/39_tn.9222249e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/39_tn.jpg
// module id = 527
// module chunks = 0